export default __webpack_public_path__ + "static/media/Rafael2.9c8bb50f.svg";